/** Platform administration — English, the source of the other languages */
const admin = {
  "admin.module.webhooks.label": "Webhooks",
  "admin.module.webhooks.desc": "Outgoing HTTP webhooks on events",
  "admin.module.branding.label": "Branding",
  "admin.module.branding.desc": "Own logo, colours, white label",
  "admin.module.apiKeys.label": "API keys",
  "admin.module.apiKeys.desc": "Access to the API for scripts and other systems",
  "admin.module.templates.label": "Templates",
  "admin.module.templates.desc": "Network configuration templates and wizard",
  "admin.module.customDomain.label": "Own domain",
  "admin.module.customDomain.desc": "Sign-in under the company’s own address",
  "admin.module.customEmail.label": "Own mail server",
  "admin.module.customEmail.desc": "SMTP per company",
  "admin.module.sso.label": "Single sign-on",
  "admin.module.sso.desc": "Sign-in through the company's identity provider (OpenID Connect)",
  "admin.module.ownWhatsapp.label": "Own WhatsApp",
  "admin.module.ownWhatsapp.desc": "The company's own Meta or Twilio account",
  "admin.module.ownRcs.label": "Own RCS",
  "admin.module.ownRcs.desc": "The company's own RCS sender (Google or Twilio)",
  "admin.module.linkedWhatsapp.label": "Linked WhatsApp number",
  "admin.module.linkedWhatsapp.desc": "The company links its own WhatsApp number to the server (open-wa)",
  "admin.module.unifi.label": "UniFi",
  "admin.module.unifi.desc": "UniFi controllers and Site Manager",
  "admin.module.teltonika.label": "Teltonika",
  "admin.module.teltonika.desc": "RutOS devices and RMS",
  "admin.module.peplink.label": "Peplink",
  "admin.module.peplink.desc": "Peplink devices and InControl2",
  "admin.module.mikrotik.label": "MikroTik",
  "admin.module.mikrotik.desc": "RouterOS routers, access points and radio links",
  "admin.module.velanox.label": "Velanox One Speed",
  "admin.module.velanox.desc": "Velanox boxes and endpoints",
  "admin.overview.title": "Platform overview",
  "admin.overview.subtitle": "Dashboard of the platform administration",
  "admin.overview.companies": "Companies",
  "admin.overview.users": "Users",
  "admin.overview.sites": "Sites",
  "admin.overview.pendingJobs": "Pending jobs",
  "admin.overview.revocations": "Certificate revocations being retried",
  "admin.overview.revocationsText": "These VPN certificates could not be revoked yet, so they still work. Each is retried (at most an hour apart) until it succeeds.",
  "admin.overview.siteCert": "Site certificate",
  "admin.overview.userCert": "User certificate",
  "admin.overview.tries": { one: "{count} try · next try {when}", other: "{count} tries · next try {when}" },
  "admin.overview.byStatus": "Companies by status",
  "admin.overview.jobs": "Job queue",
  "admin.overview.all": "All",
  "admin.overview.refreshJobs": "Refresh jobs",
  "admin.overview.noJobs": "No jobs",
  "admin.overview.audit": "Recent audit log",
  "admin.overview.noAudit": "No audit log entries",
  "admin.overview.system": "System",
  "admin.vpn.title": "VPN management",
  "admin.vpn.subtitle": "OpenVPN servers, the networks and accounts of every company",
  "admin.vpn.refresh": "Refresh",
  "admin.vpn.server": "Server",
  "admin.vpn.running": "Running",
  "admin.vpn.stopped": "Stopped",
  "admin.vpn.since": "Since {when}",
  "admin.vpn.connectedNow": "Connected now",
  "admin.vpn.ofActive": { one: "of {count} active account", other: "of {count} active accounts" },
  "admin.vpn.totalAccounts": "Total accounts",
  "admin.vpn.acrossCompanies": { one: "across {count} company", other: "across {count} companies" },
  "admin.vpn.networks": "Networks",
  "admin.vpn.isolated": "separate /24 subnets",
  "admin.vpn.currentlyConnected": "Connected now ({count})",
  "admin.vpn.commonName": "Common name",
  "admin.vpn.realIp": "Real IP",
  "admin.vpn.sinceCol": "Since",
  "admin.vpn.usersSites": "Users: {users} · Sites: {sites}",
  "admin.vpn.connectedOf": { one: "{connected} connected / {count} account", other: "{connected} connected / {count} accounts" },
  "admin.vpn.noAccounts": "No VPN accounts yet",
  "admin.vpn.name": "Name",
  "admin.vpn.logs": "OpenVPN logs",
  "admin.vpn.logLines": "Log lines",
  "admin.vpn.lines": { one: "{count} line", other: "{count} lines" },
  "admin.vpn.refreshLogs": "Refresh logs",
  "admin.vpn.hide": "Hide",
  "admin.vpn.showLogs": "Show logs",
  "admin.vpn.loadHint": "Choose \"Show logs\" to load them",
  "admin.plans.toggleFailed": "Not changed",
  "admin.plans.deleted": "Plan deleted",
  "admin.plans.deleteFailed": "The plan cannot be deleted — it may have active licences",
  "admin.plans.title": "Licence plans",
  "admin.plans.subtitle": "Reusable licence types and the modules they unlock",
  "admin.plans.new": "New plan",
  "admin.plans.deleteConfirm": "Delete plan \"{name}\"? Companies using it keep their current licence.",
  "admin.plans.empty": "No licence plans yet — create one to start giving it to companies",
  "admin.plans.createTitle": "Create licence plan",
  "admin.plans.created": "Plan created",
  "admin.plans.editTitle": "Edit: {name}",
  "admin.plans.updated": "Plan updated",
  "admin.plans.public": "Public",
  "admin.plans.activeCount": { one: "{count} active", other: "{count} active" },
  "admin.plans.editNamed": "Edit {name}",
  "admin.plans.deleteNamed": "Delete {name}",
  "admin.plans.sites": "Sites",
  "admin.plans.users": "Users",
  "admin.plans.duration": "Duration",
  "admin.plans.daysShort": "{count} d",
  "admin.plans.modules": "Modules",
  "admin.plans.nameRequired": "A name is required",
  "admin.plans.saveFailed": "The plan could not be saved",
  "admin.plans.name": "Plan name *",
  "admin.plans.namePlaceholder": "e.g. Professional",
  "admin.plans.description": "Description",
  "admin.plans.descriptionPlaceholder": "Optional description",
  "admin.plans.limits": "Limits",
  "admin.plans.limitsHint": "(leave empty for no limit)",
  "admin.plans.maxSites": "Maximum sites",
  "admin.plans.maxUsers": "Maximum users",
  "admin.plans.durationDays": "Duration (days)",
  "admin.plans.included": "Included modules",
  "admin.plans.selfSignup": "Available for self-signup",
  "admin.plans.selfSignupHint": "Show this plan on the registration page",
  "admin.plans.save": "Save plan",
  "admin.admins.removed": "Global admin removed",
  "admin.admins.removeFailed": "Remove failed",
  "admin.admins.reset2faDone": "Two-factor sign-in reset",
  "admin.admins.reset2faText": "They are signed out everywhere and set it up again at their next sign-in.",
  "admin.admins.resetFailed": "Reset failed",
  "admin.admins.title": "Global administrators",
  "admin.admins.subtitle": "People with global-admin rights: Platform administration for every company",
  "admin.admins.add": "Add global admin",
  "admin.admins.warning": "Global admins have full access to every company, setting and piece of data on the platform. Give this only to trusted staff.",
  "admin.admins.name": "Name",
  "admin.admins.email": "Email",
  "admin.admins.role": "Role",
  "admin.admins.lastLogin": "Last sign-in",
  "admin.admins.created": "Created",
  "admin.admins.empty": "No global admins found",
  "admin.admins.you": "(you)",
  "admin.admins.owner": "Owner",
  "admin.admins.superAdmin": "Super admin",
  "admin.admins.admin": "Admin",
  "admin.admins.invited": "Invited",
  "admin.admins.never": "Never",
  "admin.admins.edit": "Edit",
  "admin.admins.editNamed": "Edit {name}",
  "admin.admins.reset2fa": "Reset two-factor sign-in",
  "admin.admins.reset2faFor": "Reset two-factor sign-in for {name}",
  "admin.admins.reset2faConfirm": "Reset two-factor sign-in for \"{name}\"? They are signed out everywhere and set it up again at their next sign-in.",
  "admin.admins.ownerFixed": "The platform owner cannot be removed",
  "admin.admins.notSelf": "You cannot remove your own rights",
  "admin.admins.remove": "Remove",
  "admin.admins.removeNamed": "Remove {name} as global admin",
  "admin.admins.removeConfirm": "Remove \"{name}\" ({email}) as global admin? An account that belongs to companies keeps them; one without is deleted.",
  "admin.admins.ownHint": "Your own name, password and two-factor sign-in are under",
  "admin.admins.invitationSent": "Invitation sent",
  "admin.admins.invitationText": "{email} sets a password from the mail, then two-factor sign-in.",
  "admin.admins.added": "Global admin added",
  "admin.admins.addedText": "Their account now has global-admin rights.",
  "admin.admins.editTitle": "Edit: {name}",
  "admin.admins.updated": "Admin updated",
  "admin.admins.required": "A name and an email address are required",
  "admin.admins.saveFailed": "Save failed",
  "admin.admins.fullName": "Full name *",
  "admin.admins.emailAddress": "Email address *",
  "admin.admins.emailAddressPlain": "Email address",
  "admin.admins.emailHint": "An existing account gets the rights. A new address gets a mail to set a password.",
  "admin.admins.emailFixed": "The email address cannot be changed",
  "admin.admins.superAdminHint": "Can manage other global admins and settings critical to the platform",
  "admin.admins.saveChanges": "Save changes",
  "admin.admins.sendInvitation": "Send invitation",
  "admin.settings.provider": "Provider",
  "admin.settings.serverSettings": "Use the server's settings (.env)",
  "admin.settings.off": "Off",
  "admin.settings.waHint": "Once Meta or Twilio is chosen here, only the values on this page count: nothing is taken from the server's settings. Saved changes apply at once, without a restart. Tokens are stored encrypted and never shown again. Companies with the licence module Own WhatsApp can use their own connection instead (Company settings → WhatsApp).",
  "admin.settings.changedProvider": "You changed the provider: save the settings to use it.",
  "admin.settings.rcsHint": "RCS messages arrive in the phone's own messages app, from your verified business name. Once Google or Twilio is chosen here, only the values on this page count. Saved changes apply at once. Keys and tokens are stored encrypted and never shown again. Companies with the licence module Own RCS can use their own sender instead (Company settings → RCS).",
  "admin.settings.templatesChecked": "Templates checked",
  "admin.settings.syncFailed": "Sync failed",
  "admin.settings.tryAgain": "Try again in a moment.",
  "admin.settings.templatesOff": "When WhatsApp goes through Twilio (chosen above, or in the server's settings), the platform makes the templates itself and companies can change their texts. With Meta, the templates named in its settings are used.",
  "admin.settings.templatesIntro": "WhatsApp approves every text before it can be used. New texts are submitted and verdicts fetched every 30 minutes; until a company's own text is approved, the default goes out.",
  "admin.settings.templatesInUse": { one: "{count} template in use. WhatsApp allows {unverified} per business account, or {verified} once the business is verified with Meta. Each company’s own WhatsApp text is a template of its own.", other: "{count} templates in use. WhatsApp allows {unverified} per business account, or {verified} once the business is verified with Meta. Each company’s own WhatsApp text is a template of its own." },
  "admin.settings.nearLimit": "Close to the limit of an unverified business account ({limit}). Verify the business with Meta, or new texts cannot be approved once it is reached.",
  "admin.settings.message": "Message",
  "admin.settings.text": "Text",
  "admin.settings.usedBy": "Used by",
  "admin.settings.authMessage": "WhatsApp's own verification code message",
  "admin.settings.usedBy.default": "Default",
  "admin.settings.usedBy.previousDefault": "Previous default, until the new text is approved",
  "admin.settings.notUsed": "No longer used",
  "admin.settings.wa.approved": "approved",
  "admin.settings.wa.rejected": "rejected",
  "admin.settings.wa.failed": "not submitted",
  "admin.settings.wa.paused": "paused",
  "admin.settings.wa.disabled": "disabled",
  "admin.settings.wa.pending": "waiting",
  "admin.settings.noTemplates": "None yet: the first sync makes them.",
  "admin.settings.syncNow": "Sync now",
  "admin.settings.testSent": "Test email sent",
  "admin.settings.checkInbox": "Check {to}",
  "admin.settings.smtpFailed": "SMTP test failed",
  "admin.settings.save": "Save settings",
  "admin.settings.title": "Platform settings",
  "admin.settings.subtitle": "Global behaviour, email, WhatsApp, RCS and VPN",
  "admin.settings.tab": "Settings",
  "admin.settings.edgeTab": "Edge proxy (Caddy + HAProxy) →",
  "admin.settings.loading": "Loading",
  "admin.settings.behaviour": "Platform behaviour",
  "admin.settings.licensing": "Licensing on",
  "admin.settings.licensingHint": "Enforce licence limits. Switch off for unlimited access.",
  "admin.settings.maintenance": "Maintenance mode",
  "admin.settings.maintenanceHint": "Stop company users from signing in. Global admins still have access.",
  "admin.settings.selfRegistration": "Allow self-registration",
  "admin.settings.selfRegistrationHint": "Let companies sign up without an invitation from a global admin.",
  "admin.settings.adminIdle": "Global admins: sign out after a time without activity, at most",
  "admin.settings.adminIdleHint": "1 hour by default; each admin can choose a shorter time under My profile.",
  "admin.settings.idleOff": "Admins may switch signing out after inactivity off",
  "admin.settings.idleOffHint": "For their own account.",
  "admin.settings.idleOffWarning": "Allowing this lets global admins switch off one of the account protections of the platform: an admin session left open on an unattended computer then stays signed in until it reaches its maximum length.",
  "admin.settings.idleOffQuestion": "Allow it?",
  "admin.settings.defaultLicense": "Default licence type",
  "admin.settings.licenseType.TRIAL": "Trial",
  "admin.settings.licenseType.STANDARD": "Standard",
  "admin.settings.licenseType.UNLIMITED": "Unlimited",
  "admin.settings.licenseType.CUSTOM": "Custom",
  "admin.settings.trialDays": "Default trial days",
  "admin.settings.email": "Email / SMTP",
  "admin.settings.emailIntro": "Defaults for the whole platform. Companies can use their own SMTP in their company settings. Passwords are encrypted with AES-256 before storage.",
  "admin.settings.smtpHost": "SMTP host",
  "admin.settings.smtpPort": "SMTP port",
  "admin.settings.username": "Username",
  "admin.settings.password": "Password",
  "admin.settings.saved": "✓ saved",
  "admin.settings.keepPassword": "(leave empty to keep the current one)",
  "admin.settings.enterPassword": "SMTP password",
  "admin.settings.hidePassword": "Hide password",
  "admin.settings.showPassword": "Show password",
  "admin.settings.fromEmail": "From email",
  "admin.settings.fromName": "From name",
  "admin.settings.sendTest": "Send test email",
  "admin.settings.testRecipient": "Test recipient",
  "admin.settings.testRecipientPlaceholder": "your@email.com",
  "admin.settings.send": "Send test",
  "admin.settings.waTemplates": "WhatsApp templates",
  "admin.settings.vpn": "VPN / OpenVPN",
  "admin.settings.vpnIntro": "Controls the VPN for new companies. Each company gets its own /24 subnet.",
  "admin.settings.serverHost": "Server hostname / IP",
  "admin.settings.usersBase": "Users network base",
  "admin.settings.sitesBase": "Sites network base",
  "admin.settings.usersExample": "Company 1 → 10.8.1.0/24 · Company 2 → 10.8.2.0/24 …",
  "admin.settings.sitesExample": "Company 1 → 10.9.1.0/24 · Company 2 → 10.9.2.0/24 …",
  "admin.licences.deleted": "Licence deleted",
  "admin.licences.deleteFailed": "Delete failed",
  "admin.licences.notified": "Email sent to the company admins",
  "admin.licences.notifyFailed": "The email could not be sent",
  "admin.licences.keyRevoked": "Key revoked",
  "admin.licences.revokeFailed": "Revoke failed",
  "admin.licences.unusedDeleted": "Unused keys deleted",
  "admin.licences.expiredDeleted": "Expired licences deleted",
  "admin.licences.bulkFailed": "Delete failed",
  "admin.licences.tab.used": "Active",
  "admin.licences.tab.available": "Keys",
  "admin.licences.tab.expired": "Expired",
  "admin.licences.title": "Licence overview",
  "admin.licences.subtitle": "Every licence and key issued on the platform",
  "admin.licences.generate": "Generate key",
  "admin.licences.activeCount": "Active licences",
  "admin.licences.availableCount": "Available keys",
  "admin.licences.expiredCount": "Expired licences",
  "admin.licences.totalKeys": "Keys issued in total",
  "admin.licences.company": "Company",
  "admin.licences.plan": "Plan",
  "admin.licences.started": "Started",
  "admin.licences.expires": "Expires",
  "admin.licences.limits": "Limits",
  "admin.licences.noActive": "No active licences",
  "admin.licences.daysLeft": { one: "{count} day left", other: "{count} days left" },
  "admin.licences.unlimited": "Unlimited",
  "admin.licences.sites": { one: "{count} site", other: "{count} sites" },
  "admin.licences.sitesUnlimited": "∞ sites",
  "admin.licences.users": { one: "{count} user", other: "{count} users" },
  "admin.licences.usersUnlimited": "∞ users",
  "admin.licences.thisCompany": "this company",
  "admin.licences.deleteFor": "Delete the licence of {name}",
  "admin.licences.deleteConfirm": "Delete the licence of \"{name}\"?",
  "admin.licences.deleteUnusedConfirm": { one: "Delete the unused key?", other: "Delete all {count} unused keys?" },
  "admin.licences.deleteUnused": "Delete all unused",
  "admin.licences.available": "Available ({count})",
  "admin.licences.key": "Key",
  "admin.licences.restriction": "Restriction",
  "admin.licences.created": "Created",
  "admin.licences.redeemed": "Redeemed ({count})",
  "admin.licences.usedBy": "Used by",
  "admin.licences.redeemedAt": "Redeemed",
  "admin.licences.noKeys": "No licence keys yet — generate some above",
  "admin.licences.deleteExpiredConfirm": { one: "Delete the expired licence?", other: "Delete all {count} expired licences?" },
  "admin.licences.deleteExpired": "Delete all expired",
  "admin.licences.expiredOn": "Expired",
  "admin.licences.durationWas": "Duration was",
  "admin.licences.noExpired": "No expired licences",
  "admin.licences.days": { one: "{count} day", other: "{count} days" },
  "admin.licences.notifyHint": "Email the company admins about the expiry",
  "admin.licences.notify": "Notify",
  "admin.licences.deleteExpiredFor": "Delete the expired licence of {name}",
  "admin.licences.deleteExpiredOne": "Delete the expired licence of \"{name}\"?",
  "admin.licences.copyKey": "Copy the full key",
  "admin.licences.anyPlan": "Any",
  "admin.licences.companyOnly": "🏢 One company only",
  "admin.licences.noRestriction": "🌐 Unlimited",
  "admin.licences.never": "Never",
  "admin.licences.revokeKey": "Revoke key",
  "admin.licences.revokeConfirm": "Revoke this key?",
  "admin.licences.generated": { one: "{count} key generated", other: "{count} keys generated" },
  "admin.licences.generateFailed": "Generation failed",
  "admin.licences.generateTitle": { one: "Generate licence key", other: "Generate licence keys" },
  "admin.licences.sendKeys": "Copy and send these keys to your customers. They can redeem them when they sign up or in their account settings.",
  "admin.licences.copy": "Copy",
  "admin.licences.allCopied": "All keys copied",
  "admin.licences.copyAll": "Copy all",
  "admin.licences.done": "Done",
  "admin.licences.licencePlan": "Licence plan",
  "admin.licences.anyPlanOption": "Any plan (no restriction)",
  "admin.licences.restrict.unlimited": "🌐 Unlimited",
  "admin.licences.restrict.email": "📧 Email",
  "admin.licences.restrict.company": "🏢 Company",
  "admin.licences.limitEmail": "Limit to email",
  "admin.licences.limitCompany": "Limit to company",
  "admin.licences.chooseCompany": "Choose a company…",
  "admin.licences.count": "Number of keys",
  "admin.licences.keyExpires": "Key expires",
  "admin.licences.optional": "(optional)",
  "admin.licences.notes": "Notes",
  "admin.licences.notesPlaceholder": "Internal note about this batch of keys",
  "admin.licences.generateCount": { one: "Generate key", other: "Generate {count} keys" },
  "admin.edge.resolves": "{domain} resolves correctly",
  "admin.edge.dnsNotHere": "The DNS does not point here yet",
  "admin.edge.resolvesTo": "Resolves to {ips}",
  "admin.edge.noARecord": "No A record found",
  "admin.edge.proven": "Ownership proven",
  "admin.edge.servesNow": "The domain now serves the dashboard.",
  "admin.edge.notProvenYet": "Not proven yet",
  "admin.edge.markedProven": "Marked as proven",
  "admin.edge.ownershipReset": "Ownership reset",
  "admin.edge.resetText": "The domain shows the setup page until the new TXT record is found.",
  "admin.edge.failed": "Failed",
  "admin.edge.requestFailed": "The request failed",
  "admin.edge.removed": "Domain removed",
  "admin.edge.caddyApplied": "Caddy configuration applied",
  "admin.edge.caddyRejected": "Caddy rejected the configuration",
  "admin.edge.title": "Edge proxy",
  "admin.edge.subtitle": "HAProxy in front of :80/:443 · Caddy terminates TLS and issues certificates on demand · OpenVPN per company over UDP",
  "admin.edge.addDomain": "Add domain",
  "admin.edge.connections": { one: "{count} connection", other: "{count} connections" },
  "admin.edge.notReachable": "Not reachable",
  "admin.edge.onDemandOn": "On-demand TLS active",
  "admin.edge.onDemandOff": "On-demand TLS NOT configured",
  "admin.edge.edgeIp": "Edge IP",
  "admin.edge.noEdgeIp": "Not set — customers cannot be told where to point their DNS",
  "admin.edge.acme": "ACME: {email}",
  "admin.edge.noAcme": "No ACME email address set",
  "admin.edge.caddyWarnBefore": "Caddy is running, but on-demand TLS is not linked to the ask endpoint. White-label domains will not get certificates until you push the configuration — use ",
  "admin.edge.caddyWarnAfter": " under Configuration.",
  "admin.edge.tab.domains": "Domains ({count})",
  "admin.edge.tab.vpn": "VPN instances",
  "admin.edge.tab.config": "Configuration",
  "admin.edge.domain": "Domain",
  "admin.edge.type": "Type",
  "admin.edge.company": "Company",
  "admin.edge.dns": "DNS",
  "admin.edge.ownership": "Ownership",
  "admin.edge.certificate": "Certificate",
  "admin.edge.noDomains": "No domains yet",
  "admin.edge.typeName.WHITELABEL": "White-label",
  "admin.edge.typeName.PLATFORM": "Platform",
  "admin.edge.typeName.APP": "Other app",
  "admin.edge.typeName.REDIRECT": "Redirect",
  "admin.edge.typeName.VPN": "VPN",
  "admin.edge.typeDesc.WHITELABEL": "A customer’s own dashboard domain",
  "admin.edge.typeDesc.PLATFORM": "Your own dashboard host name",
  "admin.edge.typeDesc.APP": "Another web app on this server",
  "admin.edge.typeDesc.REDIRECT": "Sends this name on to another",
  "admin.edge.dnsResolves": "resolves",
  "admin.edge.awaitingDns": "awaiting DNS",
  "admin.edge.provenBadge": "proven",
  "admin.edge.provenBy": "by {name}",
  "admin.edge.anAdmin": "an admin",
  "admin.edge.byDns": "by DNS record",
  "admin.edge.notProven": "not proven",
  "admin.edge.certFailed": "failed",
  "admin.edge.certOnFirst": "issued on the first request",
  "admin.edge.certAuto": "requested automatically",
  "admin.edge.pendingDns": "waiting for DNS",
  "admin.edge.recheck": "Check the DNS again",
  "admin.edge.resetOwnership": "Reset ownership",
  "admin.edge.resetConfirm": "Reset the ownership of {domain}? It shows the \"being set up\" page until the company publishes the new TXT record.",
  "admin.edge.remove": "Remove",
  "admin.edge.removeWhitelabel": "Remove {domain}? Its VPN configurations fall back to the platform host name.",
  "admin.edge.removeOther": "Remove {domain}? This server stops answering for it.",
  "admin.edge.txtRecord": "Ownership record (TXT):",
  "admin.edge.copyRecord": "Copy the record value for {domain}",
  "admin.edge.releasedOn": "Released on {date} unless proven",
  "admin.edge.checkNow": "Check now",
  "admin.edge.overrideConfirm": "Mark {domain} as proven without its TXT record? It starts serving the dashboard of {company} at once.",
  "admin.edge.theCompany": "the company",
  "admin.edge.markProven": "Mark as proven",
  "admin.edge.vpnIntroBefore": "Two OpenVPN servers per company (users and sites), each on its own UDP port. A restart or a bad configuration affects only that company. White-label companies need a ",
  "admin.edge.vpnIntroAfter": " A record pointing at the edge IP.",
  "admin.edge.theirDomain": "their-domain",
  "admin.edge.unit": "Unit",
  "admin.edge.udpPorts": "UDP ports",
  "admin.edge.connectTo": "Clients connect to",
  "admin.edge.state": "State",
  "admin.edge.noInstances": "No VPN instances provisioned",
  "admin.edge.whitelabelHost": "white-label: {domain}",
  "admin.edge.usersPort": "users {port}",
  "admin.edge.sitesPort": "sites {port}",
  "admin.edge.repoint": "Point at the current domain again",
  "admin.edge.hostRefreshed": "Remote host refreshed",
  "admin.edge.reprovision": "Provision again",
  "admin.edge.vpnRunning": "VPN servers running",
  "admin.edge.queued": { one: "{count} account that could not be made before is queued", other: "{count} accounts that could not be made before are queued" },
  "admin.edge.vpnNotRunning": "VPN servers not running",
  "admin.edge.provisionFailed": "Provisioning failed",
  "admin.edge.stop": "Stop",
  "admin.edge.stopConfirm": "Stop the VPN of {company}? Its tunnels will drop.",
  "admin.edge.attention": "Needs attention",
  "admin.edge.healthy": "Healthy",
  "admin.edge.unreachable": "Unreachable",
  "admin.edge.caddyText": "Pushes the generated configuration over the admin API. Platform domains are listed explicitly; white-label domains use on-demand TLS gated by the ask endpoint, so adding one needs no reload.",
  "admin.edge.applyCaddy": "Apply Caddy configuration",
  "admin.edge.haproxyText1": "Set up by the installer and only changed when the edge itself changes shape. The configuration it should have is below: to put it in place, copy it to ",
  "admin.edge.haproxyText2": " on the server, check it with ",
  "admin.edge.haproxyText3": ", move it over ",
  "admin.edge.haproxyText4": " and run ",
  "admin.edge.haproxyText5": ". The dashboard does not write it: the API runs without root.",
  "admin.edge.generatedCfg": "Generated haproxy.cfg",
  "admin.edge.copy": "Copy",
  "admin.edge.registered": "Domain registered",
  "admin.edge.addFailed": "The domain could not be added",
  "admin.edge.registeredTitle": "{domain} registered",
  "admin.edge.currentlyResolves": "Currently resolves to: {ips}",
  "admin.edge.done": "Done",
  "admin.edge.domainLabel": "Domain *",
  "admin.edge.pointA": "Point an A record at ",
  "admin.edge.certSoon": " The certificate is requested as soon as the name resolves here.",
  "admin.edge.certFirst": " The certificate is issued automatically on the first request.",
  "admin.edge.pointASuffix": ".",
  "admin.edge.portLabel": "Port on this server *",
  "admin.edge.portHint": "https://{domain} goes to http://127.0.0.1:{port}, with nothing of the dashboard in between. Ports that HAProxy, Caddy or the dashboard use are refused.",
  "admin.edge.redirectLabel": "Redirect to *",
  "admin.edge.redirectHint": "A host name. Every request goes there over HTTPS with its own path and query, as a permanent redirect.",
  "admin.edge.companyLabel": "Company *",
  "admin.edge.chooseCompany": "Choose a company…",
  "admin.edge.vpnSwitchBefore": "Its VPN configurations switch to ",
  "admin.edge.vpnSwitchAfter": " automatically.",
  "admin.edge.step.prove": "Prove that you own {domain}: add a TXT record named {name} with the value {value}. Until then {domain} shows a \"being set up\" page.",
  "admin.edge.step.pointAt": "Point an A record for {domain} at {ip}, then check again.",
  "admin.edge.step.pointHere": "Point an A record for {domain} at this server, then check again. Set the edge public IP in the platform settings to have it checked automatically.",
  "admin.edge.step.appOk": "The DNS is correct: https://{domain} now goes to the app on port {port} of this server, and its certificate is being requested.",
  "admin.edge.step.redirectOk": "The DNS is correct: https://{domain} now redirects to https://{target}, and its certificate is being requested.",
  "admin.edge.step.dnsOk": "The DNS is correct. Caddy issues a certificate on the first request to https://{domain}.",
  "admin.edge.step.vpnRecord": "Create an A record for {host} pointing at {ip} — VPN clients connect there.",
  "admin.edge.thisServer": "this server",
  "admin.edge.step.vpnHost": "The VPN configurations of this company now use {host}. Existing .ovpn files keep working while their old host name still resolves here; download them again to switch.",
  "admin.companies.title": "Companies",
  "admin.companies.count": { one: "{count} company on the platform", other: "{count} companies on the platform" },
  "admin.companies.create": "Create company",
  "admin.companies.search": "Search companies",
  "admin.companies.searchPlaceholder": "Search by name or slug",
  "admin.companies.company": "Company",
  "admin.companies.status": "Status",
  "admin.companies.licence": "Licence",
  "admin.companies.sites": "Sites",
  "admin.companies.users": "Users",
  "admin.companies.created": "Created",
  "admin.companies.expiresOn": "Expires {date}",
  "admin.companies.edit": "Edit company",
  "admin.companies.settings": "Company settings",
  "admin.companies.usersInvites": "Users and invitations",
  "admin.companies.manageLicence": "Manage licence",
  "admin.companies.assignAdmin": "Assign admin",
  "admin.companies.delete": "Delete company",
  "admin.companies.createFailed": "The company could not be created",
  "admin.companies.nameLabel": "Company name *",
  "admin.companies.slugLabel": "Slug *",
  "admin.companies.adminUser": "Admin user",
  "admin.companies.adminName": "Admin name *",
  "admin.companies.adminEmail": "Admin email address *",
  "admin.companies.licenceTypeLabel": "Licence type",
  "admin.companies.trial30": "Trial (30 days)",
  "admin.companies.expiryDate": "Expiry date",
  "admin.companies.maxSites": "Max. sites",
  "admin.companies.maxUsers": "Max. users",
  "admin.companies.unlimited": "Unlimited",
  "admin.companies.licenceUpdated": "Licence updated",
  "admin.companies.saveFailed": "Save failed",
  "admin.companies.assignLicence": "Assign licence",
  "admin.companies.fromPlan": "📋 From a plan",
  "admin.companies.manual": "✏️ By hand",
  "admin.companies.licencePlan": "Licence plan",
  "admin.companies.noPlansBefore": "No active licence plans — create one under ",
  "admin.companies.noPlansLink": "Licence plans",
  "admin.companies.noPlansAfter": " first.",
  "admin.companies.blankUnlimited": "(empty = unlimited)",
  "admin.companies.modules": "Modules",
  "admin.companies.modulesHint": "Set by hand, these apply instead of a plan’s: saving detaches the licence from its plan. Choosing a plan later uses the plan’s modules again.",
  "admin.companies.notes": "Notes",
  "admin.companies.internalNote": "Internal note",
  "admin.companies.inviteSent": "Invitation sent",
  "admin.companies.inviteResent": "The invitation was sent to the user again.",
  "admin.companies.resendFailed": "The invitation could not be sent again",
  "admin.companies.twoFactorReset": "Two-factor sign-in reset",
  "admin.companies.twoFactorResetText": "They are signed out everywhere and set it up again when they next sign in.",
  "admin.companies.resetFailed": "Reset failed",
  "admin.companies.usersTitle": "Company users",
  "admin.companies.noUsers": "No users in this company",
  "admin.companies.twoFactorOn": "Two-factor sign-in is on",
  "admin.companies.resendInvite": "Send the invitation again",
  "admin.companies.resend": "Resend",
  "admin.companies.reset2fa": "Reset two-factor sign-in",
  "admin.companies.reset2faFor": "Reset two-factor sign-in for {name}",
  "admin.companies.reset2faConfirm": "Reset two-factor sign-in for \"{name}\"? They are signed out everywhere and set it up again when they next sign in.",
  "admin.companies.updateFailed": "The company could not be updated",
  "admin.companies.domainPlaceholder": "e.g. portal.acme.com",
  "admin.companies.statusName.PENDING_SETUP": "Being set up",
  "admin.companies.statusName.ACTIVE": "Active",
  "admin.companies.statusName.SUSPENDED": "Suspended",
  "admin.companies.statusName.CANCELLED": "Cancelled",
  "admin.companies.saveChanges": "Save changes",
  "admin.companies.notSaved": "Settings not saved",
  "admin.companies.tryAgain": "Try again in a moment.",
  "admin.companies.monitoring": "Monitoring",
  "admin.companies.timezone": "Time zone",
  "admin.companies.language": "Language",
  "admin.companies.ownMail": "Own mail server (instead of the platform’s)",
  "admin.companies.mailInUse": "In use: the company’s own mail server.",
  "admin.companies.mailNotYet": "Not in use yet: until the company’s admin sends a test email from Company settings, its mail goes through the platform’s mail server.",
  "admin.companies.port": "Port",
  "admin.companies.passwordSaved": "✓ saved",
  "admin.companies.deleteFailed": "Delete failed",
  "admin.companies.couldNotDelete": "The company could not be deleted",
  "admin.companies.permanent": "This is permanent.",
  "admin.companies.deleteTextBefore": " All sites, users, templates, monitoring data, VPN configurations and settings of ",
  "admin.companies.deleteTextAfter": " are deleted at once and cannot be recovered.",
  "admin.companies.typeBefore": "Type ",
  "admin.companies.typeAfter": " to confirm",
  "admin.companies.deletePermanently": "Delete permanently",
  "admin.companies.userInvited": "User invited",
  "admin.companies.userUpdated": "User updated",
  "admin.companies.invitedText": "An invitation was sent to {email}. They set their password through that email.",
  "admin.companies.nowAdmin": "{email} is now an admin of this company.",
  "admin.companies.nowMember": "{email} is now a member of this company.",
  "admin.companies.assignFailed": "The user could not be assigned",
  "admin.companies.assignTitle": "Assign or invite a user",
  "admin.companies.assignIntro": "Enter an email address to invite someone to this company. Someone who already has a Velanox account is added at once; anyone else receives an invitation to set a password.",
  "admin.companies.emailLabel": "Email address *",
  "admin.companies.nameOnlyNew": "(only needed for new accounts)",
  "admin.companies.makeAdmin": "Make company admin",
  "admin.companies.makeAdminHint": "On: full admin access. Off: added as an ordinary member only.",
  "admin.companies.assignAsAdmin": "Assign as company admin",
  "admin.companies.inviteAsMember": "Invite as member",
  "admin.module.rental.label": "Rental",
  "admin.module.rental.desc": "Stock, planning, events and purchasing for renting out material",
  "admin.edge.mikrotikPort": "MikroTik {port}",
  "admin.edge.vpnRunningNoMikrotik": "VPN servers running — the MikroTik server did not start",
  "admin.module.omada.label": "Omada",
  "admin.module.omada.desc": "TP-Link Omada controllers: their sites, access points, switches and gateways",
  "admin.module.ruckus.label": "Ruckus",
  "admin.module.ruckus.desc": "Ruckus SmartZone controllers: their zones, access points and clients",
  "admin.module.starlink.label": "Starlink",
  "admin.module.starlink.desc": "A Starlink business account: its terminals, their data and their service",
  "admin.models.title": "Models",
  "admin.models.subtitle": "Every device model the fleet reports, the new ones, and what Velanox only partly reads",
  "admin.models.inUse": "In use",
  "admin.models.gone": "Gone",
  "admin.models.brand": "Brand",
  "admin.models.allBrands": "All brands",
  "admin.models.col.model": "Model",
  "admin.models.col.devices": "Devices",
  "admin.models.col.companies": "Companies",
  "admin.models.col.firmware": "Firmware",
  "admin.models.col.firstSeen": "First seen",
  "admin.models.col.lastSeen": "Last seen",
  "admin.models.col.partly": "Partly read",
  "admin.models.new": "New",
  "admin.models.partly": "Partly read ({n})",
  "admin.models.times": "met {times}×",
  "admin.models.noExample": "Example site removed",
  "admin.models.example": "{site} ({company})",
  "admin.models.none": "No models seen yet",
  "admin.models.noneGone": "No models gone",
  "admin.models.kind.interface_type": "Interface type",
  "admin.models.kind.part_not_answering": "Part not answering",
  "admin.models.kind.device_type": "Device type",
  "admin.models.kind.wan_type": "WAN type",
  "admin.models.kind.dish_alert": "Dish alert field",
  "admin.settings.push.title": "Push notifications",
  "admin.settings.push.intro": "Pushes to the Velanox app go through Firebase. With its key this installation sends them itself; without it, through the Velanox relay.",
  "admin.settings.push.direct": "Sent directly through Firebase with this installation's key",
  "admin.settings.push.off": "Off: no Firebase key, and the relay is switched off (PUSH_RELAY_URL)",
  "admin.settings.push.viaRelay": "Through the Velanox relay",
  "admin.settings.push.relayState.not_signed_up": "signs up with the first push",
  "admin.settings.push.relayState.signed_up": "signed up",
  "admin.settings.push.relayState.blocked": "blocked by the relay",
  "admin.settings.push.key": "Firebase key",
  "admin.settings.push.project": "Project {project}",
  "admin.settings.push.upload": "Upload the Firebase key",
  "admin.settings.push.keyFile": "Firebase key file",
  "admin.settings.push.uploadHint": "The service account's JSON key from the Firebase project of the Velanox app (docs/mobile/stores.md). Only on the installation that relays.",
  "admin.settings.push.remove": "Remove the Firebase key",
  "admin.settings.push.removeConfirm": "Remove the Firebase key? Pushes then go through the Velanox relay, and other installations can no longer send through this one.",
  "admin.settings.push.relayOn": "Let other installations send through this one",
  "admin.settings.push.relayOnHint": "They sign themselves up; each has an hourly limit. See them under Push relay.",
  "admin.settings.push.test": "Send a test",
  "admin.settings.push.testSent": "Sent to {n} phone(s)",
  "admin.settings.push.testFailed": "The test push did not go out",
  "admin.pushRelay.title": "Push relay",
  "admin.pushRelay.subtitle": "Installations that send their pushes through this one: counted, never their texts",
  "admin.pushRelay.col.installation": "Installation",
  "admin.pushRelay.col.signedUp": "Signed up",
  "admin.pushRelay.col.lastPush": "Last push",
  "admin.pushRelay.col.today": "Today",
  "admin.pushRelay.col.month": "This month",
  "admin.pushRelay.col.limit": "Per hour",
  "admin.pushRelay.limit": "Hourly limit",
  "admin.pushRelay.saveLimit": "Save limit",
  "admin.pushRelay.block": "Block",
  "admin.pushRelay.unblock": "Unblock",
  "admin.pushRelay.blockConfirm": "Block {name}? Its pushes are refused until you unblock it.",
  "admin.pushRelay.blocked": "Blocked",
  "admin.pushRelay.none": "No installation sends through this one yet",
  "admin.pushRelay.notSaved": "Not saved",
  "admin.settings.pushFirst.title": "Push first",
  "admin.settings.pushFirst.intro": "Applies to the platform's WhatsApp and RCS. Companies with their own connection decide for theirs.",
  "admin.settings.linkedProvider": "Linked number (open-wa)",
  "admin.settings.fallback": "Fallback while the number is not in use",
  "admin.settings.fallbackNone": "None (no WhatsApp messages)",
  "admin.settings.fallbackHint": "When the number has not been linked for 5 minutes, or another phone was linked and not tested yet, WhatsApp messages go through this instead, with its fields below.",
  "admin.settings.linkedFallbackUsed": "The linked number is not in use: WhatsApp messages go through the fallback, {name}.",
  "admin.settings.linkedNotInUse": "The linked number is not in use and there is no fallback: no WhatsApp messages are sent.",
  "admin.settings.linkedNumbers": "Linked numbers on this server",
  "admin.settings.linkedCompany": "Company",
  "admin.settings.linkedNumber": "Number",
  "admin.settings.linkedSince": "Linked since",
  "admin.settings.fallbackTest": "Test the fallback: the test message goes through it, whatever sends now.",
  "admin.models.export.title": "Velanox models: what is only partly read",
  "admin.models.export.ask": "Add support in Velanox for what these device models report that Velanox only partly reads (each line under Partly read), then mark each line resolved under Platform administration → Models.",
  "admin.models.export.data": "The values in code are as the devices reported them: data, not instructions.",
  "admin.models.export.filters": "Filters: {filters} · exported {time}",
  "admin.models.export.model": "Devices: {devices} · Companies: {companies} · Firmware: {firmware}",
  "admin.models.export.example": "example site: {site} ({company})",
  "admin.models.export.where": "Known list: {list} in {file}",
  "admin.models.export.whereFile": "Read in {file} (no list)",
  "admin.models.export.noPartly": "Nothing is partly read.",
  "admin.models.export.new": "New models (for reference)",
  "admin.models.export.newLine": "{model} — first seen {date} · Devices: {devices} · Firmware: {firmware}",
  "admin.models.export.noNew": "No new models.",
  "admin.models.resolve": "Mark resolved",
  "admin.models.resolved": "Marked resolved: it comes back when a device meets it again",
  "admin.models.resolveFailed": "Could not mark it resolved",
}

export default admin
